import { twJoin } from "tailwind-merge";

import type { ImageDto } from "@/api/types";
import { UserAvatar } from "@/components/UserAvatar/UserAvatar";

interface Props {
  images: (ImageDto | undefined)[];
  limit: number;
  totalElements?: number;
  isGreyedOut?: boolean;
  onClick?: () => void;
  "data-testid"?: string;
}

export function UserAvatarList(props: Props): React.ReactNode {
  const elementsToShow = props.images.slice(0, props.limit);
  const amountOfRestElements = props.totalElements
    ? props.totalElements - elementsToShow.length
    : props.images.length - elementsToShow.length;

  const Component = props.onClick ? "button" : "div";

  return (
    <Component
      className="flex items-center gap-space-xs"
      onClick={props.onClick}
      type={props.onClick ? "button" : undefined}
    >
      <div
        className={twJoin(
          "flex h-full items-center -space-x-2 overflow-hidden",
          props.onClick ? "cursor-pointer" : undefined,
        )}
        data-testid={props["data-testid"]}
      >
        {elementsToShow.map((image, index) => (
          <div key={image?.id || index} data-testid="avatar-item">
            <UserAvatar size="xs" image={image} />
          </div>
        ))}
      </div>
      {amountOfRestElements > 0 && <span className="text-overline-emphasis">{`+${amountOfRestElements}`}</span>}
    </Component>
  );
}
